import React from 'react';
import styled from 'styled-components';

const IconLink = (props) => {
  const { children, startIcon: Icon, href, mailTo, className } = props;

  let as = 'button';
  const customProps = {};
  if (href || mailTo) {
    as = 'a';
    customProps.href = href;
    customProps.target = '_blank';
    customProps.rel = 'noreferrer';
  }
  if (mailTo) {
    customProps.href = `mailto:${mailTo}`;
  }

  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <StyledIconLink as={as} {...customProps} className={className}>
      <Icon />
      {children}
    </StyledIconLink>
  );
};

const StyledIconLink = styled.button`
  border: none;
  background-color: #fff;
  color: var(--black);
  padding: 0;
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 15px;

  ${({ as }) => (as === 'a' ? 'color: var(--blue-base);' : '')}

  svg {
    width: 19px;
    path {
      fill: var(--gray-medium);
    }
  }
`;

export default IconLink;
